export default __webpack_public_path__ + "static/media/bloemkool.6ea5a0bc.png";